<template>
  <div class="col table-responsive">
    <!-- table for foil peel data -->
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">ID</th>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">QS</th>
          <th scope="col" class="multi-line-header">Test Type</th>
          <th scope="col" class="multi-line-header">Test enspricht</th>
          <th scope="col" class="multi-line-header">Laminator</th>
          <th scope="col" class="multi-line-header">Lami Programm</th>
          <th scope="col" class="multi-line-header">Frontglas Dicke</th>
          <th scope="col" class="multi-line-header">Frontglas Charge Nr.</th>
          <th scope="col" class="multi-line-header">
            Frontglas Produktionsdatum
          </th>
          <th scope="col" class="multi-line-header">EVA Typ</th>
          <th scope="col" class="multi-line-header">EVA Charge Nr.</th>
          <th scope="col" class="multi-line-header">Backssheet Typ</th>
          <th scope="col" class="multi-line-header">Backssheet Charge Nr.</th>
          <th scope="col" class="multi-line-header">Glas gereingt?</th>
          <th scope="col" class="multi-line-header">
            Position auf dem Einfuhtisch
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entries" :key="tableId">
          <td>{{ entry.id }}</td>

          <td>{{ entry.dateInProduction?.replace("T", " ") || "" }}</td>

          <td>{{ entry.username }}</td>

          <td>{{ entry.testType }}</td>

          <td>{{ entry.testForArticle }}</td>

          <td>{{ entry.laminatorName }}</td>

          <td>{{ entry.laminatorRecipe }}</td>

          <td>{{ entry.frontGlassThickness }}mm</td>

          <td>{{ entry.frontGlassBatchNumber }}</td>

          <td>
            {{ entry.frontGlassManufacturingDate?.replace("T", " ") || "" }}
          </td>

          <td>{{ entry.evaFoilType }}</td>

          <td>{{ entry.evaFoilBatchNumber }}</td>

          <td>{{ entry.backsheetType }}</td>

          <td>{{ entry.evaFoilManufacturingDate?.replace("T", " ") || "" }}</td>

          <td v-if="entry.isGlassCleaned">Ja</td>
          <td v-else>Nein</td>

          <td>{{ entry.laminatorPosition }}</td>
        </tr>
      </tbody>
    </table>
    <FoilPeelAdhesionTable :url-adhesion-test="urlTests" :key="componentKey" />
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import FoilPeelAdhesionTable from "@/components/foilpeel/FoilPeelAdhesionTable.vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  urlFoilPeelData: {
    type: String,
    required: true,
  },
});

const componentKey = ref(0);

let urlTests = `/Material/GetLastAdhesionTestByFoilPeelIds?`;

const entries = ref([]);

const fetchData = async (url) => {
  let response;
  try {
    response = await axios.get(url);
  } catch (error) {
    console.error("Netzwerkproblem:", error.message);
    return;
  }

  try {
    if (response.status !== 200) {
      console.log(response);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.data;
    entries.value = data;

    const foilPeelIdsString = entries.value
      .map((entry) => `foilPeelIds=${entry.id}`)
      .join("&");

    urlTests = `${urlTests}${foilPeelIdsString}`;
    componentKey.value = +1;
  } catch (error) {
    console.error("Datenverarbeitungsproblem:", error.message);
  }
};

onMounted(() => {
  fetchData(props.urlFoilPeelData);
});
</script>

<style scoped>
@media (max-width: 768px) {
  th {
    white-space: normal;
    word-wrap: break-word;
  }
}

.criteria {
  color: darkorange !important;
}
</style>
